import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-guanbi",
  "use": "icon-guanbi-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-guanbi\"><path fill=\"#ffffff\" d=\"M893.7 924.8c-8.4 0-16.5-3.3-22.4-9.3L108 152.2c-12.4-12.4-12.4-32.4 0-44.8 12.4-12.4 32.4-12.4 44.8 0l763.3 763.3c9 9.1 11.6 22.7 6.7 34.5-4.9 11.8-16.4 19.5-29.1 19.6M130.4 924.8c-12.8 0.1-24.4-7.7-29.4-19.5-4.9-11.9-2.2-25.5 7-34.6l763.3-763.3c12.5-11.4 31.8-10.9 43.8 1.1 12 12 12.4 31.3 1 43.8L152.8 915.5c-5.9 5.9-14 9.3-22.4 9.3\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol